export default __webpack_public_path__ + "static/media/Casa Dionisio.ede2f296.jpg";